module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Year of Biblical Womanhood")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txcm11",
    staticStyle: {
      "margin-top": "25%"
    },
    attrs: {
      "id": "p0012-01-0"
    }
  }, [_c('span', [_c('i', [_vm._v("Consider the lilies—is the only commandment I ever obeyed.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txcm11m",
    attrs: {
      "id": "p0012-02-1"
    }
  }, [_c('span', [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MILY")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKINSON")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60530fdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 78
// module chunks = 0